export default [
  {
    name: "Olusola's System",
    powerNow: '1.226kW',
    monthlyEnergy: '621.86kWh',
    monthlyBill: '0 €',
    totalEnergy: '92206kWh',
    totalBill: '0 €',
    operation: 'view dashbaord'
  },
  {
    name: "Peace's System",
    powerNow: '595w',
    monthlyEnergy: '758.58Wh',
    monthlyBill: '75.86 €',
    totalEnergy: '3111.81kWh',
    totalBill: '311.18 €',
    operation: 'view dashbaord'
  }
];
